import { z } from 'zod';
import { createToolSignature } from './tool-signature';

export const getUsersLinkedinPostsToolSignature = createToolSignature({
    name: 'getUsersLinkedinPostsTool',
    description: 'Get all LinkedIn posts, posted by the user.',
    inputSchema: z.object({}),
    outputSchema: z.object({
        posts: z.array(
            z.object({
                postId: z.string().describe('The LinkedIn post ID.'),
                authorMemberId: z.string().describe('The LinkedIn member ID of the author of the post.'),
                contentText: z.string().describe('The text content of the post.'),
                postedOn: z.date().optional().describe('The date and time when the post was posted.'),
                article: z
                    .object({
                        text: z.string(),
                        link: z.string(),
                    })
                    .optional(),
                numberOfComments: z.number().optional().describe('The number of comments on the post.'),
                numberOfReactions: z.number().optional().describe('The number of reactions on the post.'),
                ugcUrn: z.string().optional(),
                images: z.array(z.string()).optional(),
                video: z.string().nullable().optional(),
                repost: z
                    .object({
                        postId: z.string(),
                        postedOn: z.date().optional(),
                        contentText: z.string(),
                        article: z
                            .object({
                                text: z.string(),
                                link: z.string(),
                            })
                            .optional(),
                        images: z.array(z.string()),
                        video: z.string().nullable().optional(),
                    })
                    .optional(),
                // createdAt: z.date().optional(),
                // updatedAt: z.date().optional(),
            }),
        ),
    }),
    toolCallUi: (input) => `Getting your Linkedin posts`,
});
